import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { SupportList } from '@/features/support/SupportList'
import SupportListPagenation from '@/features/support/SupportListPagenation'
import STYLE_GUIDE from '@/shared/constants/styleGuide'
import { useGetNews } from '@/shared/hooks/useGetItems.hook'
import { monitoredOpen } from '@/shared/utils/sentry/navigation'

const NewsListPage = () => {
  const { data } = useGetNews()
  const windowOpen = (to: string) => {
    monitoredOpen(to, 'news', 'news link')
  }
  const pageSize = 5
  const [total, setTotal] = useState(0)
  const [currentPages, setCurrentPages] = useState(5)
  const handlePageSize = () => {
    if (currentPages < total) {
      setCurrentPages((cur) => (cur += pageSize))
    }
  }
  useEffect(() => {
    if (data != null) {
      setTotal(data.length)
    }
  }, [data])
  return (
    <SupportList.SupportListContainer>
      <SupportList.SupportListUl>
        {data != null
          ? data.map((news) => (
              <SupportList.SupportListLi key={news.Idx}>
                <NewsTitle onClick={() => windowOpen(news.LinkPath)}>{news.NewsTitle}</NewsTitle>
                <SupportList.SupportListLiDate>
                  {dayjs(news.RegDT).format('YYYY.MM.DD')}
                </SupportList.SupportListLiDate>
              </SupportList.SupportListLi>
            ))
          : '없음'}
      </SupportList.SupportListUl>
      <SupportListPagenation
        currentPages={currentPages}
        total={total}
        handlePageSize={handlePageSize}
      />
    </SupportList.SupportListContainer>
  )
}

export default NewsListPage

const NewsTitle = styled.button`
  @media screen and (min-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    width: 100%;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: -0.025em;
    text-align: left;
    padding-inline-start: 5px;
    color: black;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: none;
    background: none;
    cursor: pointer;
  }
  @media screen and (max-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    border: none;
    background: none;
    letter-spacing: -0.025em;
    text-align: left;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: black;
    overflow: hidden;
    width: 215px;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
`
